import { useCallback, useContext } from 'react'
import { ItemPageContext } from '../contexts/ItemPageContext'
import { isIncludedTopping } from '../helpers'

/*
* Our API routes return the generic prices of the toppings, but depending upon rules and current set of toppings on the item,
* the topping prices may be different, this accounts for that.
* */
export function useToppingPriceUpdater() {
  const { rules, itemPageJson, tiles, hasFreeAvailable, form } = useContext(ItemPageContext)
  const { recipe_toppings } = itemPageJson

  return useCallback((toppings: ItemTopping[]) => toppings.map((topping) => {
    const formTopping = form.toppings.find((t) => t.name === topping.name && t.tile_hash_id === topping.tile_hash_id)
    const chargeableQuantity = topping.quantity - (formTopping?.free_quantity ?? 0)
    let newPrice = topping.price * chargeableQuantity

    if (hasFreeAvailable(topping) || isIncludedTopping(topping, itemPageJson)) {
      newPrice = 0
    } else {
      const regularTopping = recipe_toppings.find((t) => t.name === topping.name && t.portion_name === 'Regular')
      const isRegularIncluded = isIncludedTopping(regularTopping, itemPageJson)

      /* If we are pricing the "extra" but the recipe comes with the topping, we need to deduct the "regular" pricing from the "extra" pricing */
      if (topping.portion_name === 'Extra') {
        if (isRegularIncluded) {
          newPrice = topping.section_topping_price - regularTopping.section_topping_price
        } else if (formTopping?.free_quantity > 0) {
          newPrice = topping.section_topping_price - formTopping.section_topping_price
        }
      }
    }

    return {
      ...topping,
      price: newPrice,
    }
  }), [form.toppings, hasFreeAvailable, itemPageJson, recipe_toppings])
}
